import * as React from "react";
import { forwardRef } from "react";
const SvgCheckicon = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: "1em", height: "1em", viewBox: "0 0 17 13", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M6.127 8.235 2.323 4.43.149 6.604l5.978 5.979L16.453 2.256 14.28.083z", fill: "#000", fillRule: "evenodd" }));
const ForwardRef = forwardRef(SvgCheckicon);
export default ForwardRef;
